export default __webpack_public_path__ + "static/media/gesture-two-finger-tap.3dc77351.svg";